/**
 * GPS coordinate point (latitude and longitude in degrees)
 */
export class PointGps {
  constructor(
    public readonly lat: number,
    public readonly lon: number
  ) {}
}
